import RichText from "@src/components/Widget/RichText";
import ArrayImage from "@src/packages/pro-component/schema/ArrayImage";
import ArraySelect from "@src/packages/pro-component/schema/ArraySelect";
import Image from "@src/packages/pro-component/schema/Image";
import SingleModel from "@src/packages/pro-component/schema/SingleModel";
import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  InputNumber,
  Row,
  Select,
  Switch,
} from "antd";
import { FormInstance } from "antd/lib/form";
import React from "react";
// Ticket layout sẽ thiết kế ở step riêng

interface EventSectionProps {
  form: FormInstance;
  pageId?: number;
  onGoLayoutStep?: () => void;
}

const EventSection: React.FC<EventSectionProps> = ({
  pageId,
  form,
  onGoLayoutStep,
}) => {
  // chuyển sang step layout bằng nút

  return (
    <>
      <Form.Item
        name={["envent", "nameEvent"]}
        label="Tên sự kiện"
        rules={[{ required: true, message: "Nhập tên sự kiện" }]}
      >
        <Input />
      </Form.Item>
      <Divider orientation="left">Hình ảnh</Divider>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "image"]}
            label="Ảnh sự kiện"
            rules={[{ required: true, message: "Chọn ảnh" }]}
          >
            <Image />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "banner"]}
            label="Banner sự kiện"
            rules={[{ message: "Chọn ảnh" }]}
          >
            <ArrayImage />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name={["envent", "description"]} label="Mô tả">
        <RichText height={300} />
      </Form.Item>
      <Divider orientation="left">Thời gian sự kiện</Divider>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "startDateEvent"]}
            label="Bắt đầu sự kiện"
            rules={[{ required: true, message: "Chọn thời gian" }]}
          >
            <Input type="datetime-local" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "endDateEvent"]}
            label="Kết thúc sự kiện"
            rules={[{ required: true, message: "Chọn thời gian" }]}
          >
            <Input type="datetime-local" />
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation="left">Cửa bán vé</Divider>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "presaleStart"]}
            label="Bắt đầu bán vé"
            rules={[{ required: true, message: "Chọn thời gian" }]}
          >
            <Input type="datetime-local" />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "presaleEnd"]}
            label="Kết thúc bán vé"
            rules={[{ required: true, message: "Chọn thời gian" }]}
          >
            <Input type="datetime-local" />
          </Form.Item>
        </Col>
      </Row>
      <Divider orientation="left">Địa điểm & Layout</Divider>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "stadiumId"]}
            label="Sân vận động"
            rules={[{ required: true, message: "Chọn sân vận động" }]}
          >
            <SingleModel
              schema={{
                pageId: pageId || 120,
                api: "find_stadium",
                modelSelectMultiple: false,
                modelSelectField: "id$$ID,name$$Tên sân",
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <div style={{ marginTop: 30 }}>
            <Button
              type="primary"
              onClick={() => {
                if (onGoLayoutStep) {
                  onGoLayoutStep();
                  return;
                }
                form.setFieldsValue({ __goToLayoutStep: true });
              }}
            >
              Thiết kế layout
            </Button>
          </div>
        </Col>
      </Row>
      <Divider orientation="left">Thiết lập khác</Divider>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "status"]}
            label="Trạng thái sự kiện"
            rules={[{ required: true }]}
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "isTicketsVaidForMultipleSeasons"]}
            label="Vé dùng cho nhiều mùa giải"
            valuePropName="checked"
          >
            <Switch />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        noStyle
        shouldUpdate={(prev, cur) =>
          prev?.envent?.isTicketsVaidForMultipleSeasons !==
          cur?.envent?.isTicketsVaidForMultipleSeasons
        }
      >
        {({ getFieldValue }) => {
          const isMultiSeasons = getFieldValue([
            "envent",
            "isTicketsVaidForMultipleSeasons",
          ]);
          if (isMultiSeasons) {
            return (
              <Row gutter={12} style={{ width: "100%" }}>
                <Col span={24}>
                  <Form.Item
                    name={["envent", "matchIds"]}
                    label="Trận đấu áp dụng"
                    rules={[{ required: true, message: "Chọn trận đấu" }]}
                    style={{ width: "100%" }}
                  >
                    <ArraySelect
                      schema={{
                        api: "find_match",
                        modelSelectField: "id$$ID,name$$Trận đấu,year$$Năm",
                        pageId: pageId || 120,
                      }}
                      placeholder="Chọn trận đấu"
                    />
                  </Form.Item>
                </Col>
              </Row>
            );
          }
          return (
            <Row gutter={12} style={{ width: "100%" }}>
              <Col span={24}>
                <Form.Item
                  name={["envent", "matchId"]}
                  label="Trận đấu diễn ra"
                  rules={[{ required: true, message: "Chọn trận đấu" }]}
                >
                  <SingleModel
                    schema={{
                      pageId: pageId || 120,
                      api: "find_match",
                      modelSelectMultiple: false,
                      modelSelectField: "id$$ID,name$$Trận đấu,year$$Năm",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
          );
        }}
      </Form.Item>
      <Row gutter={12}>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "maxItemsPerOrder"]}
            label="Tối đa / đơn"
            rules={[{ required: true }]}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
        </Col>
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "maxItemsPerCustomer"]}
            label="Tối đa / khách hàng"
            rules={[{ required: true }]}
          >
            <InputNumber style={{ width: "100%" }} min={1} />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={12}>
        {/* <Form.Item
          noStyle
          shouldUpdate={(prev, cur) =>
            prev?.envent?.isTicketsVaidForMultipleSeasons !==
            cur?.envent?.isTicketsVaidForMultipleSeasons
          }
        >
          {({ getFieldValue }) => {
            const isMultiSeasons = getFieldValue([
              "envent",
              "isTicketsVaidForMultipleSeasons",
            ]);
            if (isMultiSeasons) return null;
            return (
              <Col xs={24} md={12}>
                <Form.Item
                  name={["envent", "checkInTime"]}
                  label="Giờ check-in"
                  rules={[{ required: true }]}
                >
                  <Input type="datetime-local" />
                </Form.Item>
              </Col>
            );
          }}
        </Form.Item> */}
        <Col xs={24} md={12}>
          <Form.Item
            name={["envent", "salesChannels"]}
            label="Kênh bán vé"
            rules={[{ required: true, message: "Chọn ít nhất 1 kênh" }]}
          >
            <Select
              mode="multiple"
              options={[
                { value: "ONLINE", label: "ONLINE" },
                { value: "INVITATION", label: "INVITATION" },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>

      {/* <Form.Item noStyle shouldUpdate={(prev, cur) => prev?.envent?.isTicketsVaidForMultipleSeasons !== cur?.envent?.isTicketsVaidForMultipleSeasons}>
        {({ getFieldValue }) => {
          const enabled = !!getFieldValue(["envent", "isTicketsVaidForMultipleSeasons"]);
          if (!enabled) return null;
          return (
            <Form.Item
              name={["envent", "tournamentIds"]}
              label="Giải đấu áp dụng"
            >
              <ArrayModel
                schema={{
                  name: 'Giải đấu',
                  field: 'tournamentIds',
                  widget: 'ArrayModel',
                  type: 'number',
                  api: 'find_tournament',
                  modelSelectField: 'id$$ID,name$$Tên,year$$Năm',
                  pageId: pageId || 120,
                }}
                value={'tournamentIds'}
              />
            </Form.Item>
          );
        }}
      </Form.Item> */}

      {/* Modal editor tại EventSection không còn dùng; chuyển sang step Layout */}
    </>
  );
};

export default EventSection;
